export const iconFontAwesomeChartsDiagramsChartPie = (
	<i className="fa-solid fa-chart-pie"></i>
);
